import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const categories = [
  { name: 'CRM & Sales', icons: [FiIcons.FiUsers, FiIcons.FiTarget, FiIcons.FiTrendingUp] },
  { name: 'Marketing', icons: [FiIcons.FiMail, FiIcons.FiMessageSquare, FiIcons.FiShare2] },
  { name: 'Operations', icons: [FiIcons.FiCalendar, FiIcons.FiClipboard, FiIcons.FiDatabase] },
  { name: 'Communication', icons: [FiIcons.FiSlack, FiIcons.FiMessageCircle, FiIcons.FiVideo] }
];

const NimaIntegrationGrid = () => {
  return (
    <section className="py-24 bg-indigo-900 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold mb-6">
              An Expanded Library <br />
              <span className="text-cyan-400">For Every Major Category</span>
            </h2>
            <p className="text-indigo-100 text-lg mb-12 leading-relaxed">
              Whether you need to sync registrations with HubSpot, send instant Slack alerts for VIP arrivals, or trigger post-event surveys via Mailchimp, Nima has you covered.
            </p>
            
            <div className="grid grid-cols-2 gap-4">
              {categories.map((cat, i) => (
                <div key={i} className="p-6 bg-white/5 rounded-2xl border border-white/10">
                  <h4 className="font-bold text-white mb-4">{cat.name}</h4>
                  <div className="flex gap-3">
                    {cat.icons.map((Icon, idx) => (
                      <SafeIcon key={idx} icon={Icon} className="w-5 h-5 text-cyan-400" />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="bg-white/5 backdrop-blur-xl border border-white/10 p-8 rounded-3xl relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-500 via-cyan-400 to-indigo-500"></div>
              <div className="space-y-6">
                <div className="flex items-center gap-4 p-4 bg-white/10 rounded-xl border border-white/5">
                  <div className="w-10 h-10 rounded-lg bg-indigo-500 flex items-center justify-center">
                    <SafeIcon icon={FiIcons.FiPlus} className="text-white" />
                  </div>
                  <div className="flex-1">
                    <div className="h-2 w-24 bg-white/20 rounded mb-2"></div>
                    <div className="h-2 w-16 bg-white/10 rounded"></div>
                  </div>
                </div>
                <div className="flex justify-center">
                  <SafeIcon icon={FiIcons.FiChevronDown} className="text-indigo-400 animate-bounce" />
                </div>
                <div className="flex items-center gap-4 p-4 bg-cyan-500/20 rounded-xl border border-cyan-500/30">
                  <div className="w-10 h-10 rounded-lg bg-cyan-500 flex items-center justify-center">
                    <SafeIcon icon={FiIcons.FiCheck} className="text-white" />
                  </div>
                  <div className="flex-1">
                    <div className="h-2 w-32 bg-white/40 rounded mb-2"></div>
                    <div className="h-2 w-20 bg-white/20 rounded"></div>
                  </div>
                </div>
              </div>
            </div>
            {/* Background Glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-cyan-500/20 blur-[100px] -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NimaIntegrationGrid;